import { List, Map } from 'immutable';

import { FIND, OPERATIONS, REPLACE } from '../../../../constants/bulkEdit';
import { VALUE } from '../../../../constants/product';

import { ATTRIBUTE } from '../../../../constants/attributes';

export function barcode({ channel, operation, preview }) {
  return {
    payload: Map({
      type: operation,
      value: List([
        Map({
          combination: null,
          offeringId: null,
          value: operation === OPERATIONS[channel].BARCODE.FIND_AND_REPLACE
            ? Map({
              find: preview.getIn([ATTRIBUTE.BARCODE, FIND]),
              replace: preview.getIn([ATTRIBUTE.BARCODE, REPLACE]),
            })
            : preview.getIn([ATTRIBUTE.BARCODE, VALUE]),
        }),
      ]),
    }),
  };
}
